import React, { Fragment, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Navigation from '../lp2/Navigation';
import api from '../api';
import TabHeute from './TabHeute';
import TabNutzer from './TabNutzer';
import TabZahlungen from './TabZahlungen';
import TabBetrieb from './TabBetrieb';
import TabFunnel from './TabFunnel';

const TABS = [
  { id: 'heute', label: 'Heute', Inhalt: TabHeute },
  { id: 'nutzer', label: 'Nutzer', Inhalt: TabNutzer },
  { id: 'zahlungen', label: 'Zahlungen', Inhalt: TabZahlungen },
  { id: 'funnel', label: 'Funnel', Inhalt: TabFunnel },
  { id: 'betrieb', label: 'Betrieb', Inhalt: TabBetrieb },
];

const AdminPage = () => {
  const [zustand, setZustand] = useState('pruefe');   // pruefe | erlaubt | verweigert
  const [tab, setTab] = useState('heute');
  const navigate = useNavigate();

  useEffect(() => {
    // Die Oberflaeche prueft nur, um nichts Sinnloses anzuzeigen. Die
    // eigentliche Zugangskontrolle steht serverseitig an jedem Endpunkt.
    api.get('/profile')
      .then((r) => setZustand(r.data?.isAdmin ? 'erlaubt' : 'verweigert'))
      .catch((e) => {
        if (e?.response?.status === 401) { navigate('/login'); return; }
        setZustand('verweigert');
      });
  }, [navigate]);

  if (zustand === 'pruefe') {
    return (
      <Fragment>
        <Navigation />
        <div className="min-h-screen bg-gray-50 flex items-center justify-center">
          <p className="text-gray-500">Prüfe Berechtigung …</p>
        </div>
      </Fragment>
    );
  }

  if (zustand === 'verweigert') {
    return (
      <Fragment>
        <Navigation />
        <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
          <div className="bg-white border border-gray-200 rounded-xl p-8 text-center max-w-md">
            <h1 className="text-xl font-semibold text-gray-900 mb-2">Kein Zugriff</h1>
            <p className="text-gray-600 text-sm">
              Dieser Bereich ist der Verwaltung vorbehalten.
            </p>
          </div>
        </div>
      </Fragment>
    );
  }

  const Aktiv = TABS.find((t) => t.id === tab).Inhalt;

  return (
    <Fragment>
      <Navigation />
      <div className="min-h-screen bg-gray-50">
        <div className="max-w-6xl mx-auto px-4 py-8">
          <h1 className="text-2xl font-bold text-gray-900 mb-6">Verwaltung</h1>

          <div className="flex gap-1 mb-6 border-b border-gray-200 overflow-x-auto" role="tablist">
            {TABS.map((t) => (
              <button
                key={t.id}
                role="tab"
                aria-selected={tab === t.id}
                onClick={() => setTab(t.id)}
                className={`px-4 py-2 text-sm font-medium border-b-2 -mb-px whitespace-nowrap ${
                  tab === t.id
                    ? 'border-blue-600 text-blue-700'
                    : 'border-transparent text-gray-500 hover:text-gray-700'
                }`}
              >
                {t.label}
              </button>
            ))}
          </div>

          <Aktiv />
        </div>
      </div>
    </Fragment>
  );
};

export default AdminPage;
